var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "rootNode",
      staticClass: "app-notifications",
      on: { click: _vm.clicked }
    },
    [
      _c("header", [
        _c("div", { staticClass: "unread-count" }, [
          _vm._v("\n      " + _vm._s(_vm.unread) + "\n    ")
        ]),
        _vm._v(" "),
        _c("h1", [_vm._v(_vm._s(_vm.$t("notifications.new-unread")))])
      ]),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "notifications-list" },
        _vm._l(_vm.latestNotifications, function(notification) {
          return _c("li", { key: notification.id }, [
            !notification.read
              ? _c("div", { staticClass: "unread-circle" })
              : _vm._e(),
            _vm._v(" "),
            _c("div", {
              staticClass: "notification-body",
              domProps: {
                innerHTML: _vm._s(_vm.getNotificationBody(notification))
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "notification-time" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t("date.ago", {
                      time: _vm.getTimeDistance(notification)
                    })
                  ) +
                  "\n      "
              )
            ])
          ])
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }